import cn from 'classnames';
import React from 'react';
import { NewPage, NewPageProps } from '../../../../components/NewPage';
import { inIframe, isPollsSite } from '../../../../utils/location';
import styles from './RootWrapper.module.css';

interface RootWrapperProps extends NewPageProps {
  children: React.ReactNode;
}

export const RootWrapper: React.FC<RootWrapperProps> = ({ children, ...props }) => {
  if (inIframe()) {
    return (
      <NewPage {...props} className={cn(styles.withBorder, props.className)}>
        {children}
      </NewPage>
    );
  }

  if (isPollsSite()) {
    return children;
  }

  return (
    <NewPage {...props} className={cn(styles.withBorder, props.className)} borders="none">
      {children}
    </NewPage>
  );
};
